<template>
  <v-flex xs12 md6>
    <v-card>
      <v-card-media
        class="white--text"
        height="150px"
        src="/static/playlist_img02.jpg"
      >
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
              <span class="headline">歓談プレイリスト</span><br>
              <p>歓談中にBGMとして使用する曲を、10曲お選びください。</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-list two-line v-if="$store.state.playlist_b.length !== 0">
        <v-list-tile
          v-for="(item, index) in $store.state.playlist_b"
          :key="item.customer_playlist_product_id"
          avatar>
          <v-list-tile-avatar v-if="item.product_id === 1">
            <img src="/static/icon/ico_ISUM.png" alt="">
          </v-list-tile-avatar>
          <v-list-tile-avatar v-else-if="item.product_id === 2">
            <img src="/static/icon/ico_other.png" alt="">
          </v-list-tile-avatar>
          <play-btn
            v-else-if="item.mp3"
            :itemIndex="index"
            :itemTitle="item.name"
            :itemArtist="item.artist_name"
            :itemSrc="item.mp3"
            :itemProductId="item.product_id"
            :musicPlayerType="'playListB'"
          />
          <v-list-tile-avatar v-else></v-list-tile-avatar>
          <playListContent :item="item" :index="index" :playListType=2 />
          <div v-if="item.comment !== ''">
            <v-tooltip top>
              <v-btn flat icon color="amber darken-3" slot="activator">
                <v-icon>comment</v-icon>
              </v-btn>
              <div style="max-width: 400px;">{{ item.comment }}</div>
            </v-tooltip>
          </div>
          <more-btn
            :addIsumBtn="false"
            :addOthersBtn="true"
            :addCommentBtn="true"
            :musicBtn="true"
            :addMusicBtn="item.product_id"
            :addListBtn="false"
            :addFavoriteBtn="false"
            :deleteListBtn="false"
            :customerPlaylistProductId="item.customer_playlist_product_id"
            :productId="item.product_id"
            :commentText="item.comment"
            :playListType="2"
            :propSceneId="item.scene_id"
            :propOtherName="item.other_song_name"
            :propIsumCode="item.isum_code"
            :propIsumType="item.isum_type"
            :itemIndex=index
            @updateParentPlayList="findCustomerPlayList(2)"
          />

        </v-list-tile>
      </v-list>

      <v-list two-line v-else>
        <v-parallax src="/static/img_kanndan_blank_gray.jpg">
          <v-layout column align-center justify-center>
            <h3 class="white--text">曲を追加してください</h3>
          </v-layout>
        </v-parallax>
      </v-list>
    </v-card>
    <p v-if="countPlayListTune <= 10" class="grey--text darken-1 text-xs-right">{{ countPlayListTune }}/10</p>
    <p v-else class="red--text darken-1 text-xs-right">10曲をオーバーしています。{{ countPlayListTune }}/10</p>
  </v-flex>
</template>

<script>
import CustomerPlayListService from '@/components/services/CustomerPlayListService.vue'
import MoreBtn from '@/components/MoreBtn.vue'
import PlayBtn from '@/components/PlayBtn.vue'
import playListContent from '@/components/Modules/playListContent'

export default {
  name: 'PlayListB',
  components: {
    MoreBtn,
    PlayBtn,
    playListContent
  },
  data () {
    return {
      playlist_b: []
    }
  },
  props: {
    source: String
  },
  created () {
    this.findCustomerPlayList(2)
  },
  computed: {
    countPlayListTune () {
      return CustomerPlayListService.countPlayListTune(2)
    }
  },
  methods: {
    handleClick: function () {
      console.log('ボタン押下')
    },
    addComment: function () {
      console.log('コメント追加')
    },
    /**
     * 新郎新婦のプレイリスト情報を取得する
     **/
    findCustomerPlayList (playlistType) {
      this.$log.debug('methods: findCustomerPlayList')
      let transactionId = this.$store.state.transactionId
      CustomerPlayListService.findCustomerPlayList(playlistType, transactionId, (response) => {
        this.playlist_b = response
      }, (error) => {
        this.$log.error(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PlayListB.vue